import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { HeaderButtons, HeaderItem } from "./HeaderButtons";
import { Heading } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
/**
 * Displays a heading for rendering at the top of a tab navigation screen.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-116}
 */ export function TabHeader(param) {
    var heading = param.heading, headerRight = param.headerRight, borderBottom = param.borderBottom;
    var theme = useTheme().theme;
    var insets = useSafeAreaInsets();
    return /*#__PURE__*/ _jsx(View, {
        style: {
            paddingTop: insets.top
        },
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            style: [
                {
                    paddingTop: 30,
                    justifyContent: 'space-between',
                    paddingBottom: 10
                },
                borderBottom ? {
                    borderBottomWidth: 1,
                    borderColor: theme.color.gray600
                } : null
            ],
            children: [
                headerRight ? /*#__PURE__*/ _jsx(HeaderButtons, {
                    children: /*#__PURE__*/ _jsx(View, {
                        "aria-hidden": true,
                        pointerEvents: "none",
                        style: {
                            opacity: 0
                        },
                        children: /*#__PURE__*/ _jsx(HeaderItem, {
                            "aria-label": undefined,
                            iconName: "edit",
                            title: "",
                            onPress: function() {},
                            style: {
                                opacity: 0
                            },
                            disabled: true,
                            color: theme.color.gray500
                        })
                    })
                }) : /*#__PURE__*/ _jsx(View, {}),
                /*#__PURE__*/ _jsx(Heading, {
                    text: heading,
                    style: {
                        zIndex: 2
                    },
                    level: 1,
                    textAlign: "center"
                }),
                headerRight ? /*#__PURE__*/ _jsx(HeaderButtons, {
                    children: headerRight
                }) : /*#__PURE__*/ _jsx(View, {})
            ]
        })
    });
}
